module.exports = __webpack_public_path__ + "static/media/introduce_base1.8c1f12f8.png";